<template>
  <component
    :is="layout"
    :class="{ 'no-padding': noPadding }"
  />
</template>

<script>
import client from '@/client/apiClient';
import { useAuthStore } from '@/store/auth.module';

const defaultLayout = 'public';

export default {
  name: 'App',
  computed: {
    layout() {
      return `${this.$route.meta.layout || defaultLayout}Layout`;
    },
    noPadding() {
      return this.$route.meta.noPadding ?? false;
    },
  },
  created() {
    const authStore = useAuthStore();

    client.interceptors.request.use(
      (request) => {
        const { jwt } = authStore;
        if (jwt) {
          request.headers.Authorization = `Bearer ${jwt}`;
        }

        return request;
      },
    );
    client.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.config && error.response && error.response.status === 401) {
          authStore.logout();
          document.location.reload();
        }
        return Promise.reject(error);
      },
    );
  },
};
</script>

<style lang="scss">
.cookie-dialog {
  position: absolute;
  bottom: 50px;
  right: 0;
  margin: 0 !important;
}
</style>
